import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { HorarioTrabajo } from 'app/models/horarios-trabajo';
import { IboxtoolsItem } from 'app/models/iboxtools-item';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ErroresService } from '../../../core/services/errores.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmacionComponent } from '../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../components/shared/dialog-procesando/dialog-procesando.component';
import { HorariosTrabajoService } from '../../../services/horarios-trabajo.service';
import { PlanHorarioReglasService } from '../../../services/plan-horario-reglas.service';
import { MyValidations } from '../../../utils/my-validations';
import { GruposLiquidacionService } from '../../../services/gruposLiquidacion.service';
import { MomentSetService } from '../../../core/services/moment-set.service';

@Component({
  selector: 'app-horarios-trabajo',
  templateUrl: './horarios-trabajo.component.html',
  styleUrls: ['./horarios-trabajo.component.css']
})
export class HorariosTrabajoComponent implements OnInit, OnChanges {
  @Input() legajo;
  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;

  horario: any;
  form: FormGroup;
  horariosList: any[];
  cortarRegistro: boolean = false;
  horariosInvalida: boolean = false;
  tipoEvaluacionList:any[]=[];

  constructor(private horariosTrabajoService: HorariosTrabajoService, 
              private planHorarioReglasService: PlanHorarioReglasService,
              private fb: FormBuilder, 
              private dialog: MatDialog, 
              private snackBar: MatSnackBar, 
              private erroresService: ErroresService,
              private gruposLiquidacionService: GruposLiquidacionService,
              private momentService: MomentSetService) { }

  MensajeError: string;
  disabledEditing: boolean = true;
  eliminando: boolean;
  eliminacionInvalida: boolean;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  submitted = false;

  horariosHistoryList: any;
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;

  ingreso: any;
  reglasList: any;
  public cargaCompleta = false;

  get registerFormControl() { return this.form?.controls; }

  ngOnInit(): void
  {
    this.tipoEvaluacionList = this.horariosTrabajoService.getTiposEvaluacion();

    this.planHorarioReglasService.getAll().subscribe(data =>{this.reglasList = data});
    
    this.configurarValidadores();
    this.obtenerActual();
    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Horarios de Trabajo")) this.permisoEdicion = true;
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      desde: ['', Validators.required],
      hasta: ['', [Validators.required, MyValidations.fecHastaMenor]],
      personal: ['', Validators.required],
      porcentajeAsignacion: ['', Validators.required],
      diasLaboralSemana: ['', Validators.required],
      hsTrabajoDiario: ['', Validators.required],
      hsTrabSemana: ['', Validators.required],
      hsTrabMes: ['', Validators.required],
      hsTrabAnio: ['', Validators.required],
      reglaHt: ['', Validators.required],
      tipoEvaluacion: ['', Validators.required]
    });
  }

  ngOnChanges(changes: SimpleChanges)
  {
  }

  setearForm(horarioTrabajo: HorarioTrabajo)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(horarioTrabajo?.id);
      this.form.controls['personal'].setValue(horarioTrabajo?.personal);
      this.form.controls['desde'].setValue(new Date(horarioTrabajo?.desde));
      this.form.controls['hasta'].setValue(new Date(horarioTrabajo?.hasta));
      this.form.controls['porcentajeAsignacion'].setValue(horarioTrabajo?.porcentajeAsignacion);
      this.form.controls['hsTrabajoDiario'].setValue(horarioTrabajo?.hsTrabajoDiario);
      this.form.controls['hsTrabSemana'].setValue(horarioTrabajo?.hsTrabSemana);
      this.form.controls['hsTrabMes'].setValue(horarioTrabajo?.hsTrabMes);
      this.form.controls['hsTrabAnio'].setValue(horarioTrabajo?.hsTrabAnio);
      this.form.controls['diasLaboralSemana'].setValue(horarioTrabajo?.diasLaboralSemana);
      this.form.controls['reglaHt'].setValue(horarioTrabajo?.reglaHt);
      this.form.controls['tipoEvaluacion'].setValue(horarioTrabajo?.tipoEvaluacion);

      if (horarioTrabajo != null && horarioTrabajo.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }

      this.form.controls['diasLaboralSemana'].disable();
      this.form.controls['hsTrabajoDiario'].disable();
      this.form.controls['hsTrabSemana'].disable();
      this.form.controls['hsTrabMes'].disable();
      this.form.controls['hsTrabAnio'].disable();
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.horario))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.horariosTrabajoService.delete(this.horario.id).subscribe(
            response =>
            {
              this.snackBar.open("Horario de trabajo eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              this.obtenerActual();
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.horario))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.form.controls['desde'].disable();
        $this.form.controls['hasta'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let horarioTrabajo = this.horariosList.find(d => d.id == index);
    this.horario = horarioTrabajo;
    this.setearForm(this.horario);
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    if (this.horariosList != undefined)
    {
      if (this.horario.id == 0 && this.horariosList.length == 0)
      {
        this.horario = null;
      }
      else if (this.horario.id == 0 && this.horariosList.length > 0)
      {
        this.horario = this.horariosList[0];
      }
    }
    else
    {
      this.horario = null;
    }

    this.setearForm(this.horario);
    this.deshabilitarEdicion();
  }

  OnSaveChange(e: boolean)
  {
    this.submitted = true;
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.form.getRawValue();

      let datosHor: HorarioTrabajo = {
        id: formulario.id,
        personal: formulario.personal,
        desde: this.momentService.saveDateServer(formulario.desde, false),
        hasta: this.momentService.saveDateServer(formulario.hasta, false),
        porcentajeAsignacion: formulario.porcentajeAsignacion,
        diasLaboralSemana: formulario.diasLaboralSemana,
        hsTrabajoDiario: formulario.hsTrabajoDiario,
        hsTrabSemana: formulario.hsTrabSemana,
        hsTrabMes: formulario.hsTrabMes,
        hsTrabAnio: formulario.hsTrabAnio,
        reglaHt: formulario.reglaHt,
        tipoEvaluacion: formulario.tipoEvaluacion
      };

      this.horariosTrabajoService.save(datosHor, this.cortarRegistro).subscribe(
        horario =>
        {
          horario.desde = this.momentService.convertDateServer(horario.desde);
          horario.hasta = this.momentService.convertDateServer(horario.hasta);
          
          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Horario de trabajo guardado", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial();
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          //horario.desde = horario.desde.replace('Z', '');
          this.setearForm(horario);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
            this.MensajeError = this.erroresService.MostrarError400(error);            
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      let fdesde = new Date().toString();
      let fecha = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
      if (fecha != undefined){
        fdesde = fecha.desde
      }
      let horarioTrabajo: HorarioTrabajo = { id: 0, personal: this.personalId, desde: fdesde, hasta: new Date("2999-12-31T23:59:59").toString() };
      this.horario = horarioTrabajo;
      this.setearForm(horarioTrabajo);

      this.habilitarEdicion();
      this.form.controls['id'].setValue(0);
      this.form.controls['hasta'].setValue(new Date("2999-12-31T23:59:59"));
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      setTimeout(function ()
      {
        $this.form.controls['hasta'].disable();
      });
    }
  }

  onChangeReglaHorarioTrabajo(event)
  {
    this.form.controls['hsTrabajoDiario'].setValue(null);
    this.form.controls['hsTrabSemana'].setValue(null);
    this.form.controls['hsTrabMes'].setValue(null);
    this.form.controls['hsTrabAnio'].setValue(null);
    this.form.controls['diasLaboralSemana'].setValue(null);
    if(event.value != null)
    {
      let index = this.reglasList.findIndex(x => x.id == event.value)
      if (index != -1)
      {
        this.form.controls['hsTrabajoDiario'].setValue(this.reglasList[index].horasDeTrabajoPorDia);
        this.form.controls['hsTrabSemana'].setValue(this.reglasList[index].horasDeTrabajoPorSemana);
        this.form.controls['hsTrabMes'].setValue(this.reglasList[index].horasDeTrabajoPorMes);
        this.form.controls['hsTrabAnio'].setValue(this.reglasList[index].horasDeTrabajoPorAnio);
        this.form.controls['diasLaboralSemana'].setValue(this.reglasList[index].diasLaboralesSemanal);
      }
    }    
  }

  add()
  {    
    this.OnNewChange(true);
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarForm(false);
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarForm(true);
  }

  private volverAtras()
  {
    this.MensajeError = "";
    this.horariosHistoryList = [];
    this.horariosList = [];
    this.habilitarForm(false);
  }

  private obtenerHistorial()
  {
    this.horariosTrabajoService.getHistoryByPersonalId(this.personalId).subscribe(
      horarios =>
      {
        horarios.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.horariosHistoryList = [];

        if (horarios.length > 0)
        {
          horarios.forEach(d =>
          {
            let item = new IboxtoolsItem(d);
            this.horariosHistoryList.push(item);
          });

          this.horariosList = horarios;
        }
        else
        {
          this.setearForm(null);
          this.horario = null;
          this.horariosList = [];
        }
      },
      error =>
      {
        console.log(error);
      });
  }

  private obtenerActual()
  {
    let fechaHoy = new Date();
    fechaHoy.getTime
    this.horariosTrabajoService.getByPersonalId(this.personalId).subscribe(
      horarios =>
      {
        horarios.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });
        
        if (horarios.length > 0)
        {
          this.horario = horarios.find(f=> Date.parse(f.desde) <= fechaHoy.getTime() &&
                                           Date.parse(f.hasta) >= fechaHoy.getTime());
          
          if (this.horario == null) this.horario = horarios[0];
          this.obtenerHistorial();
        }
        else
        {
          this.horario = null;
        }
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";

    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.form.get("desde").value.toDateString();
    let hasta = this.form.get("hasta").value.toDateString();
    let hoy = new Date()

    let error = false;
    let fingreso = new Date(this.ingreso.desde).toDateString();
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      error = true;
      this.form.get("desde").setErrors({'desdeAnterior': true });
    } else {
      //valida que la fecha desde no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(desde) < Date.parse(fretro) )
        {
          error = true;
          this.form.get("desde").setErrors({'anteriorRetroactividad': true });
        }
      }
    }

    if (this.form.valid && error == false)
    {
      return true;
    }
    else
    {
      this.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(desde) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.desde);
      if(anterior) edita = false;  
    }
    return edita;
  }
  
}
